export default __webpack_public_path__ + "static/media/banner.ee4ab0d8.jpg";